<template>
  <div class="reports inside-banner mobile-top">
    <section
      class="pixelsbg bs-shadow"
      style="padding: 20px 20px 10px"
    >
      <div>
        <div v-if="loading" style="f-center">
          <div class="">
            <h1 class="text-white">Loading Report Details</h1>
          </div>
        </div>
        <div v-else class="banner-content">
          <div class="mb10" style="margin-right: -10px">
            <div class="header-bucket-wrap">
              <h3 class="text-white top-titles mb0">
                <small style="font-weight: 300; display: flex"
                  ><span class="material-icons" style="margin-right: 5px">
                    article
                  </span>
                  Viewing orders for:</small
                >{{ report.header1 }}
              </h3>
              <h3 v-if="repid.length" class="text-white top-titles mb0">
                <small style="font-weight: 300; display: flex; text-align: left; align-items: center"
                  ><span class="material-icons" style="margin-right: 5px">
                    assignment_ind
                  </span>
                  <span style="display:flex">{{ " SALES REP: " }}{{repid.replace("repid=", "").replace("&", "") }}</span>
                  </small>
              </h3>
            </div>
          </div>

          <!-- start controls -->
          <div class="search-btns">
            <div class="left-side">
              <div class="ac-select" style="margin-right: 10px"></div>

              <div
                class="dates ac-select"
                id="dates"
                style="margin-bottom: 0; flex-grow: 1; margin-right: 10px"
              >
                <div class="year-select"></div>
              </div>
            </div>
          </div>
          <!-- end controls -->
        </div>
      </div>
    </section>

    <div
      class="report-card"
      style="padding: 20px !important; min-height: 600px !important"
    >
      <div v-if="loading == true" class="row">
        <div class="col-xs-12 col-sm-12 col-12 col-lg-12">
          <div
            class="flex-box-wrap"
            style="padding: 100px 0; position: relative"
          >
            <div class="flex-internal">
              <atom-spinner
                :animation-duration="1000"
                :size="40"
                :color="'#575757'"
              />
              <p>Loading......</p>
              <p>Please be patient while we look up your data.</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="download-heading" style="margin-bottom: 10px">
          <h4 class>{{ report.header2 }}</h4>
          
        </div>
        <div class="d-flex number-showing" style="margin-bottom: 20px">

          <!--
          <router-link
            :to="{ path: $store.state.route.from.fullPath }"
            class="mb0 lh1 mrauto list-btn dib d-flex center"
          >
            <i class="material-icons">keyboard_arrow_left</i>
            Back
          </router-link>
          -->

          <back-button/>

          <download-csv
            class="mb0 lh1 mlauto list-btn dib d-flex center"
            :data="report.details"
            :name="report.header2.replace('All Orders with status of ', '') + '.csv'"
            >Download CSV</download-csv
          >
        </div>

        <div class="rfr table-responsive">
          <table
            class="table-striped table-bordered"
            style="text-align: left !important"
          >
            <thead>
              <tr>
                <th scope="col"
                class="table-link ten"
                @click="sortCol('orderNo')"
                :class="
                  columnSort == 'status' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Order</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'orderNo'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                <th scope="col"
                class="table-link twenty"
                @click="sortCol('projName')"
                :class="
                  columnSort == 'status' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Project</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'projName'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                <th scope="col"
                class="table-link ten"
                @click="sortCol('customerPoNo')"
                :class="
                  columnSort == 'customerPoNo' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Rep</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'customerPoNo'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                <th scope="col"
                class="table-link"
                @click="sortCol('salesCreditPercent')"
                :class="
                  columnSort == 'salesCreditPercent' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Sales %</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'salesCreditPercent'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                <th scope="col"
                class="table-link"
                @click="sortCol('customerPoNo')"
                :class="
                  columnSort == 'customerPoNo' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>PO</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'customerPoNo'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                <th scope="col"
                class="table-link"
                @click="sortCol('marketCode')"
                :class="
                  columnSort == 'marketCode' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Market</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'marketCode'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                <th scope="col"
                class="table-link ten"
                @click="sortCol('status')"
                :class="
                  columnSort == 'status' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Status</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'status'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                <th scope="col"
                class="table-link"
                @click="sortCol('dateEntered')"
                :class="
                  columnSort == 'dateEntered' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Entered</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'dateEntered'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                <th scope="col"
                class="table-link"
                @click="sortCol('datePromised')"
                :class="
                  columnSort == 'datePromised' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Promised</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'datePromised'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
<!--
                <th scope="col"
                class="table-link ten"
                @click="sortCol('status')"
                :class="
                  columnSort == 'status' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Invoiced</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'orderNo'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
-->
                <th scope="col"
                class="table-link ten"
                @click="sortCol('amount')"
                :class="
                  columnSort == 'amount' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>Credit</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'amount'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
                
                <th scope="col"
                class="table-link ten"
                @click="sortCol('acName')"
                :class="
                  columnSort == 'acName' ? 'column-active' : ''
                "><span style="display: flex; flex: 0 0 100%">
                  <span>AC</span>
                  <span class="ml-auto">
                    <i
                      :class="
                        columnSort == 'acName'
                          ? 'carrot-icon-active'
                          : ''
                      "
                      class="material-icons carrot-icon"
                    >
                      filter_list
                    </i>
                  </span>
                </span></th>
              </tr>
            </thead>
            <tbody>
              <tr v-bind:key="index" v-for="(report, index) in report.details">
                <td>
                  <router-link
                    :to="/order-details/ + report.orderNo"
                  >
                    {{ report.orderNo }}
                  </router-link>
                  
                </td>
                <td v-html="report.projName"></td>
                <td>{{report.salesman != "null" ? report.salesman : ""}}</td>
                <td>{{ report.salesCreditPercent }}%</td>
                <td>{{ report.customerPoNo }}</td>
                <td>{{ report.marketCode }}</td>
                <td>{{ report.status }}</td>
                <td>{{ $moment(report.dateEntered).format("MM-DD-YYYY") }}</td>
                <td>
                  <span v-if="report.status == 'In Production' || report.status == 'Released' || report.status == 'Partially Shipped' || report.status == 'Shipped' || report.status == 'In Shipping'">
                    {{ $moment(report.datePromised).format("MM-DD-YYYY") }}
                  </span>
                </td>

                <td>{{ formatPrice(report.individualAmount) }}</td>
                
                <td>{{ report.acName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
// import Avatar from "vue-avatar";
import * as d3 from "d3";
import Arc from "../components/DataViz/Arc.vue";
//import Bar from "../components/DataViz/BarBackLog";
import Bar from "../components/DataViz/BarWhite.vue";
import JsonCSV from "vue-json-csv";
import { formatCurrency } from '../utils/utils';
import BackButton from '@/components/Buttons/BackButton.vue';
import moment from "moment";

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer thisisanexampleofunauthorized"
  },
};

export default {
  name: "ReportDetails",
  components: {
    AtomSpinner,
    BackButton,
    // Avatar,
    Arc,
    Bar,
    JsonCSV,
  },
  data() {
    return {
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      acid:
        this.$route.query.acid && this.$route.query.acid.length
          ? `acid=${this.$route.query.acid}&`
          : "",
      territory:
        this.$route.query.territory && this.$route.query.territory.length
          ? `territory=${this.$route.query.territory}&`
          : "",
      status:
        this.$route.query.status && this.$route.query.status.length
          ? `status=${this.$route.query.status}&`
          : "",
      inMonth:
        this.$route.query.inmonth && this.$route.query.inmonth.length
          ? `inmonth=${this.$route.query.inmonth}&`
          : "",
      shippedMonth:
        this.$route.query.shippedmonth && this.$route.query.shippedmonth.length
          ? `shippedmonth=${this.$route.query.shippedmonth}&`
          : "",
      inYear:
        this.$route.query.inyear && this.$route.query.inyear.length
          ? `inyear=${this.$route.query.inyear}&`
          : "",
      shippedYear:
        this.$route.query.shippedyear && this.$route.query.shippedyear.length
          ? `shippedyear=${this.$route.query.shippedyear}&`
          : "",
      marketCode:
        this.$route.query.marketcode && this.$route.query.marketcode.length
          ? `marketcode=${this.$route.query.marketcode}&`
          : "",
      repid:
        this.$route.query.repid && this.$route.query.repid.length
          ? `repid=${this.$route.query.repid}&`
          : "",
      report: null,
      loading: true,
      spacesaverToken: localStorage.getItem("SSCUSER"),
      colSort: false,
      columnSort: "",
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "order-manage");
      this.setFirstLast();
      //this.getYears(2008);
      //console.log(`${this.ordermanageapi}${this.endPointCompute}`);

      return (
        axios
          .get(
            `${this.ordermanageapi}${
              window.location.pathname + window.location.search
            }`,
            auth
          )
          //.get(`${this.ordermanageapi}${this.endPointCompute}`, auth)
          .then((response) => {
            console.log(response);
            this.report = response.data;
            this.loading = false;
            document
              .getElementById("mobileScrollTarget")
              .scrollIntoView({ behavior: "smooth" });
          })
      );
    },

    sortCol: function (type) {
      console.log(type);
      this.columnSort = type;
      const COLUMN = type;

      if (this.colSort) {
        this.report.details.sort((a, b) => (a[COLUMN] > b[COLUMN] ? 1 : -1));
      } else {
        this.report.details.sort((a, b) => (a[COLUMN] < b[COLUMN] ? 1 : -1));
      }
      this.colSort = !this.colSort;
    },

    formatPrice(amount) {
      return formatCurrency(amount);
    },

    rowTotal: function (month) {
      let m = month;
      let total = m.reduce(function (prev, cur) {
        return prev + cur.salesCredit;
      }, 0);
      return total;
    },

    // Returns a new array of objects made up of full names.
    getYears: function (startYear) {
      let currentYear = new Date().getFullYear(),
        years = [];
      startYear = startYear || 1980;
      while (startYear <= currentYear) {
        years.push(startYear++);
      }
      let yearsDesc = years.reverse();
      this.yearRange = yearsDesc;
      //return yearsDesc;
    },
    setFirstLast() {
      this.userFirst = this.firstName;
      this.userLast = this.lastName;
    },
    getParams() {
      const params = new URLSearchParams(location.search);
      return params;
    },
  },

  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },
    userToken() {
      return this.$store.state.token;
    },
    endPointCompute: function () {
      return `/reportdetails?${this.acid}${this.territory}${this.status}${this.inMonth}${this.inYear}${this.shippedMonth}${this.shippedYear}${this.marketCode}${this.repid}`;
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },
  mounted() {
    //console.log(this.$route.query)
    document
      .getElementById("mobileScrollTarget")
      .scrollIntoView({ behavior: "smooth" });
    this.firstLoad();

    console.log(window.location.pathname + window.location.search);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.report-card {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  overflow: scroll;
}
.fromfortbg {
  background-color: rgba(92, 109, 126, 0.9);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 1600 800'%3E%3Cg fill-opacity='0.2'%3E%3Cg fill='%23262626'%3E%3Cpolygon points='1600 800 1400 800 1600 0'/%3E%3Cpolygon points='800 800 1600 600 1600 800'/%3E%3C/g%3E%3Cg fill='%23262626'%3E%3Cpolygon points='0 0 200 0 0 800'/%3E%3Cpolygon points='800 0 0 200 0 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.pixelsbg {
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23505a65'/%3E%3Cstop offset='1' stop-color='%23505a65' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233f474f'/%3E%3Cstop offset='1' stop-color='%233f474f' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23383e45'/%3E%3Cstop offset='1' stop-color='%23383e45' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%23474f58' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%23464f58' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%23464e57' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%23454e56' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23454d56' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%23444d55' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%23444c55' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%23434b54' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%23434b53' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23424a53' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23424a52' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23414951' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23404850' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23404750' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%233f474f' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%233f464e' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%233e454d' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%233e454c' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%233d444c' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%233d444b' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%233c434b' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%233c424a' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%233b4249' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%233b4149' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%233a4148' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%233a4047' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%23394047' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%23393f46' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%23383f46' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%23394047' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%233b4148' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%233c434a' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%233d444c' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%233f464e' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%2340474f' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23414951' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23434a53' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23444c55' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%23454d57' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%23474f58' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%2348515a' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%2349525c' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%234b545e' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%234c5560' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%234d5761' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%234f5963' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%23505a65' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%23515c67' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%23535d69' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%23545f6b' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2355616c' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2357626e' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%23586470' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%235a6672' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%235b6774' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%235c6976' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b78' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%235f6c7a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23616e7c' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%2362707d' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%2363717f' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23657381' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23667583' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23687685' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525b' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c555f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5660' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234d5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234e5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%234f5a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23505b65' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%23545f6a' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355606c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356616d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636e' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6773' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235c6976' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235d6a77' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235e6b79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%235f6d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23606e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23616f7c' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647280' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657382' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%23383e45' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='.5'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  background-color: #475059;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1950 1200'%3E%3Cdefs%3E%3CradialGradient id='a' cx='0' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23586470'/%3E%3Cstop offset='1' stop-color='%23586470' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='b' cx='1950' cy='1200' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233c768a'/%3E%3Cstop offset='1' stop-color='%233c768a' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='c' cx='975' cy='0' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23305e6e'/%3E%3Cstop offset='1' stop-color='%23305e6e' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='d' cx='975' cy='1200' r='1200' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23697887'/%3E%3Cstop offset='1' stop-color='%23697887' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='e' cx='0' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23475059'/%3E%3Cstop offset='1' stop-color='%23475059' stop-opacity='0'/%3E%3C/radialGradient%3E%3CradialGradient id='f' cx='1950' cy='0' r='800' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%231a8182'/%3E%3Cstop offset='1' stop-color='%231a8182' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Crect fill='%2346505a' x='149' y='-1' width='152' height='152'/%3E%3Crect fill='%2344515c' x='299' y='149' width='152' height='152'/%3E%3Crect fill='%2343515d' x='300' y='-1' width='151' height='151'/%3E%3Crect fill='%2341525e' x='449' y='299' width='152' height='152'/%3E%3Crect fill='%23405260' x='450' y='149' width='151' height='151'/%3E%3Crect fill='%233e5361' x='450' y='-1' width='151' height='151'/%3E%3Crect fill='%233d5462' x='600' y='299' width='151' height='152'/%3E%3Crect fill='%233c5463' x='600' y='149' width='151' height='151'/%3E%3Crect fill='%233a5565' x='600' y='-1' width='151' height='151'/%3E%3Crect fill='%23395666' x='749' y='449' width='152' height='152'/%3E%3Crect fill='%23375767' x='750' y='299' width='151' height='151'/%3E%3Crect fill='%23365969' x='750' y='149' width='151' height='151'/%3E%3Crect fill='%23345a6a' x='750' y='-1' width='151' height='151'/%3E%3Crect fill='%23335b6b' x='899' y='599' width='152' height='152'/%3E%3Crect fill='%23325d6c' x='900' y='449' width='151' height='151'/%3E%3Crect fill='%23305e6e' x='900' y='299' width='151' height='151'/%3E%3Crect fill='%232f606f' x='900' y='149' width='151' height='151'/%3E%3Crect fill='%232d6170' x='900' y='-1' width='151' height='151'/%3E%3Crect fill='%232c6372' x='1050' y='449' width='151' height='152'/%3E%3Crect fill='%232b6573' x='1050' y='299' width='151' height='151'/%3E%3Crect fill='%23296774' x='1050' y='149' width='151' height='151'/%3E%3Crect fill='%23286975' x='1050' y='-1' width='151' height='151'/%3E%3Crect fill='%23266b77' x='1200' y='299' width='151' height='152'/%3E%3Crect fill='%23256d78' x='1200' y='149' width='151' height='151'/%3E%3Crect fill='%23246f79' x='1200' y='-1' width='151' height='151'/%3E%3Crect fill='%2322727a' x='1350' y='299' width='151' height='152'/%3E%3Crect fill='%2321747c' x='1350' y='149' width='151' height='151'/%3E%3Crect fill='%2320767d' x='1350' y='-1' width='151' height='151'/%3E%3Crect fill='%231e797e' x='1500' y='149' width='151' height='152'/%3E%3Crect fill='%231d7c80' x='1500' y='-1' width='151' height='151'/%3E%3Crect fill='%231b7e81' x='1650' y='-1' width='151' height='152'/%3E%3Crect fill='%231c8083' x='1800' y='149' width='152' height='152'/%3E%3Crect fill='%231d8083' x='1649' y='150' width='152' height='151'/%3E%3Crect fill='%231f7f84' x='1800' y='300' width='152' height='151'/%3E%3Crect fill='%23217e85' x='1649' y='300' width='152' height='151'/%3E%3Crect fill='%23227e85' x='1800' y='450' width='152' height='151'/%3E%3Crect fill='%23247d86' x='1800' y='600' width='152' height='151'/%3E%3Crect fill='%23267c87' x='1649' y='450' width='152' height='151'/%3E%3Crect fill='%23287c87' x='1499' y='300' width='151' height='151'/%3E%3Crect fill='%23297b88' x='1800' y='750' width='152' height='151'/%3E%3Crect fill='%232b7a88' x='1649' y='600' width='152' height='151'/%3E%3Crect fill='%232d7a88' x='1499' y='450' width='151' height='151'/%3E%3Crect fill='%232f7989' x='1800' y='900' width='152' height='151'/%3E%3Crect fill='%23317989' x='1649' y='750' width='152' height='151'/%3E%3Crect fill='%23337889' x='1499' y='600' width='151' height='151'/%3E%3Crect fill='%2335788a' x='1349' y='450' width='151' height='151'/%3E%3Crect fill='%2337778a' x='1800' y='1049' width='152' height='151'/%3E%3Crect fill='%233a778a' x='1649' y='900' width='152' height='151'/%3E%3Crect fill='%233c768a' x='1499' y='750' width='151' height='151'/%3E%3Crect fill='%233e768a' x='1349' y='600' width='151' height='151'/%3E%3Crect fill='%2340758a' x='1199' y='450' width='151' height='151'/%3E%3Crect fill='%2343758a' x='1649' y='1050' width='152' height='151'/%3E%3Crect fill='%2345758a' x='1499' y='1049' width='151' height='152'/%3E%3Crect fill='%2347758a' x='1499' y='900' width='151' height='150'/%3E%3Crect fill='%234a758a' x='1349' y='1049' width='151' height='152'/%3E%3Crect fill='%234c748a' x='1349' y='899' width='151' height='151'/%3E%3Crect fill='%234e748a' x='1349' y='750' width='151' height='150'/%3E%3Crect fill='%2351748a' x='1199' y='1049' width='151' height='152'/%3E%3Crect fill='%2354758a' x='1199' y='899' width='151' height='151'/%3E%3Crect fill='%2356758a' x='1199' y='749' width='151' height='151'/%3E%3Crect fill='%23597589' x='1199' y='600' width='151' height='150'/%3E%3Crect fill='%235b7589' x='1049' y='1049' width='151' height='152'/%3E%3Crect fill='%235e7689' x='1049' y='899' width='151' height='151'/%3E%3Crect fill='%23617688' x='1049' y='749' width='151' height='151'/%3E%3Crect fill='%23637788' x='1049' y='600' width='151' height='150'/%3E%3Crect fill='%23667787' x='899' y='899' width='151' height='152'/%3E%3Crect fill='%2348515a' x='-1' y='149' width='152' height='152'/%3E%3Crect fill='%2349525c' x='150' y='150' width='150' height='151'/%3E%3Crect fill='%234a535d' x='-1' y='300' width='152' height='151'/%3E%3Crect fill='%234b545e' x='150' y='300' width='151' height='151'/%3E%3Crect fill='%234c565f' x='-1' y='450' width='152' height='151'/%3E%3Crect fill='%234d5761' x='-1' y='600' width='152' height='151'/%3E%3Crect fill='%234e5862' x='150' y='450' width='151' height='151'/%3E%3Crect fill='%234f5963' x='300' y='300' width='150' height='151'/%3E%3Crect fill='%23505a64' x='-1' y='750' width='152' height='151'/%3E%3Crect fill='%23515b66' x='150' y='600' width='151' height='151'/%3E%3Crect fill='%23515c67' x='300' y='450' width='151' height='151'/%3E%3Crect fill='%23525d68' x='-1' y='900' width='152' height='151'/%3E%3Crect fill='%23535e69' x='150' y='750' width='151' height='151'/%3E%3Crect fill='%2354606b' x='300' y='600' width='151' height='151'/%3E%3Crect fill='%2355616c' x='450' y='450' width='151' height='151'/%3E%3Crect fill='%2356626d' x='-1' y='1050' width='152' height='151'/%3E%3Crect fill='%2357636f' x='150' y='900' width='151' height='151'/%3E%3Crect fill='%23586470' x='300' y='750' width='151' height='151'/%3E%3Crect fill='%23596571' x='450' y='600' width='151' height='151'/%3E%3Crect fill='%235a6672' x='600' y='450' width='150' height='151'/%3E%3Crect fill='%235b6774' x='150' y='1050' width='151' height='151'/%3E%3Crect fill='%235c6875' x='300' y='1049' width='151' height='152'/%3E%3Crect fill='%235d6a76' x='300' y='900' width='151' height='150'/%3E%3Crect fill='%235e6b78' x='450' y='1049' width='151' height='152'/%3E%3Crect fill='%235f6c79' x='450' y='899' width='152' height='151'/%3E%3Crect fill='%23606d7a' x='450' y='750' width='152' height='150'/%3E%3Crect fill='%23616e7b' x='600' y='1049' width='151' height='152'/%3E%3Crect fill='%23626f7d' x='600' y='899' width='151' height='151'/%3E%3Crect fill='%2362707e' x='600' y='749' width='151' height='151'/%3E%3Crect fill='%2363717f' x='600' y='600' width='151' height='150'/%3E%3Crect fill='%23647281' x='750' y='1049' width='151' height='152'/%3E%3Crect fill='%23657482' x='750' y='899' width='150' height='151'/%3E%3Crect fill='%23667583' x='750' y='749' width='151' height='151'/%3E%3Crect fill='%23677684' x='750' y='600' width='150' height='150'/%3E%3Crect fill='%23687786' x='900' y='1050' width='150' height='151'/%3E%3Crect fill='%23475059' x='-1' y='-1' width='151' height='151'/%3E%3Crect fill='%23697887' x='900' y='750' width='150' height='150'/%3E%3Crect fill='%231a8182' x='1800' y='-1' width='151' height='151'/%3E%3Cg fill-opacity='0.79'%3E%3Crect fill='url(%23a)' width='1950' height='1200'/%3E%3Crect fill='url(%23b)' width='1950' height='1200'/%3E%3Crect fill='url(%23c)' width='1950' height='1200'/%3E%3Crect fill='url(%23d)' width='1950' height='1200'/%3E%3Crect fill='url(%23e)' width='1950' height='1200'/%3E%3Crect fill='url(%23f)' width='1950' height='1200'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.text-white {
  color: #fff;
}
.disclaimer {
  padding: 0 0 20px 0;
  font-style: italic;
}
.search-btns {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 0;
  margin-bottom: 10px;
}
select.form-control[data-v-639340da]:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575 !important;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.all-contractors {
  color: #757575 !important;
}
.mrauto {
  margin-right: auto;
}
.search-btns {
  display: flex;
  margin-top: 0;
  margin-bottom: 0;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}
.top-titles {
  font-weight: 400;
}
.top-back {
  display: inline-block;
  padding: 10px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-radius: 4px;
}
.top-back span {
  font-size: 16px;
}
.f-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.h-100 {
  height: 100%;
}
.box-hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.row-4 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex: 1;
}

/*
@media (max-width:767px) {
  .top-back {
    flex-basis: calc(50% - 12px);
  }
}

@media (max-width:560px) {
  .top-back {
    flex-basis: 100%;
  }
}
*/

.header-bucket-wrap {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  padding-right: 10px;
}
.mb10 {
  margin-bottom: 10px;
}

.left-side {
  display: flex;
  flex-grow: 1;
}
@media only screen and (max-width: 800px) {
  .left-side {
    display: block;
  }
}

.download-heading {
  display: flex;
  margin-bottom: 20px;
}
</style>
